import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import './PeriodicMessage.scss';

const PeriodicMessage = ({ 
  content, 
  daysToHide = 30,
  storageKey = 'periodicMessage', 
  className = '' 
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const checkIfShouldShow = () => {
      const lastClosedDate = localStorage.getItem(storageKey);
      
      if (!lastClosedDate) {
        // If never closed before, show the message
        setIsVisible(true);
        return;
      }
      
      const lastClosed = new Date(lastClosedDate);
      const now = new Date();
      const daysSinceLastClosed = Math.floor((now - lastClosed) / (1000 * 60 * 60 * 24));
      
      // Show message if it's been more than daysToShow days since last closed
      if (daysSinceLastClosed >= daysToHide) {
        setIsVisible(true);
      }
    };
    
    checkIfShouldShow();
  }, [daysToHide, storageKey]);

  const handleClose = () => {
    // Save current date to localStorage
    localStorage.setItem(storageKey, new Date().toISOString());
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className={`periodic-message ${className}`}>
      <div className="periodic-message-content">
        {content}
      </div>
      <button 
        className="periodic-message-close" 
        onClick={handleClose}
        aria-label="Close message"
      >
        <FontAwesomeIcon icon={faTimes} />
      </button>
    </div>
  );
};

export default PeriodicMessage;